import React, { useState, useEffect, useContext } from 'react'
import './login.scss'
import useLoginStyles from './styles'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Checkbox } from '@mui/material'
import Solarplant from '../../assets/images/solarplant.svg'
import LogoP1 from '../../assets/images/DE_logo.png'
import Background from '../../assets/images/background.svg'
import UserIcon from '../../assets/images/user.svg'
import Lockicon from '../../assets/images/lock.svg'
import { useNavigate } from 'react-router-dom'
import { loginNew, ForgotPassword } from '../../services/api'
import { useDispatch } from 'react-redux'
import { AuthContext } from '../../routes/AuthContext'
import {
  saveToken,
  saveUserType,
  saveAthurised,
  saveUserInfo,
} from '../../redux/reducers/authReducer'
import CryptoJS from 'crypto-js' // Import encryption library
import CustomAlert from '../../components/CustomAlert/CustomAlert'
import { useLocation } from 'react-router-dom'

const Login = () => {
  const classes = useLoginStyles()
  const [email, setEmail] = useState('')
  const [password, setPassWord] = useState('')
  const [error, setError] = useState(false)
  const [rememberCheck, setRememberCheck] = useState(false)
  const [loginSuccess, setLoginSuccess] = useState(false)
  const [logoutSuccess, setLogoutSuccess] = useState(false)
  const [alertOpen, setAlertOpen] = useState(false)
  const [loginorForgot, setLoginorForgot] = useState(true)
  const [alertMessage, setalertMessage] = useState(
    'You are successfully logged out'
  )
  const [userData, setUserData] = useState([])
  const { Token, setToken, Authorised, setAuthorised, UserType, setUserType } =
    useContext(AuthContext)
  const { state } = useLocation()
  useEffect(() => {
    setLogoutSuccess(state?.logoutSuccess)
    if (state?.logoutSuccess) {
      setAlertOpen(true)
    }
  }, [state?.logoutSuccess])

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleChange = (event) => {
    setPassWord(event.target.value)
  }
  const handleuUsernameChange = (event) => {
    setEmail(event.target.value)
  }
  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 0,
    width: 12,
    height: 12,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgba(255, 255, 255, 1)'
        : 'inset 0 0 0 1px rgba(255, 255, 255, 1), inset 0 -1px 0 rgba(255, 255, 255, 1)',
    backgroundColor:
      theme.palette.mode === 'dark' ? 'transparent' : 'transparent',

    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark'
          ? 'rgba(57,75,89,.5)'
          : 'rgba(206,217,224,.5)',
    },
  }))

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#A5B3FE',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 12,
      height: 12,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  })

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText('#5968B7'),
    backgroundColor: '#5968B7',
    borderColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#5968B7',
    },
    height: '2.875rem',
    textTransform: 'none',
  }))

  const Secretkey = '27363g376qh373763g363gg3546372gv2g'
  useEffect(() => {
    const storedUsername = localStorage.getItem('encryptedUsername')
    const storedPassword = localStorage.getItem('encryptedPassword')
    const storedRememberMe = localStorage.getItem('rememberMeChecked')
    if (storedRememberMe === 'true') {
      setRememberCheck(true)
    }
    if (storedUsername && storedPassword && rememberCheck) {
      const decryptedUsername = CryptoJS.AES.decrypt(
        storedUsername,
        Secretkey
      ).toString(CryptoJS.enc.Utf8)
      const decryptedPassword = CryptoJS.AES.decrypt(
        storedPassword,
        Secretkey
      ).toString(CryptoJS.enc.Utf8)
      setEmail(decryptedUsername)
      setPassWord(decryptedPassword)
    }
  }, [rememberCheck])

  const handleLoginSuccess = (tokenFromApi, resp) => {
    // localStorage.setItem('accessToken', tokenFromApi);     // Save the token in localStorage
    localStorage.setItem('userType', resp?.data?.data?.user?.type)
    localStorage.setItem('userId', resp?.data?.data?.user?.userId)
    setToken(tokenFromApi) // Set the token in the component state (optional, for immediate access without refreshing)
    navigateToHomePage(tokenFromApi, resp?.data?.data?.user?.type) // Navigate to the home page
  }

  const handleLogin = () => {
    if (email.length && password.length) {
      const data = {
        email: email,
        password: password,
      }
      loginNew(data).then((resp) => {
        if (resp?.data?.data?.token) {
          dispatch(
            saveUserInfo({
              contactNumber: resp?.data?.data?.user?.contactNumber,
              email: resp?.data?.data?.user?.email,
              type: resp?.data?.data?.user?.type,
              username: resp?.data?.data?.user?.username,
              userId: resp?.data?.data?.user?.userId,
            })
          )

          localStorage.setItem('Authorised', true)
          setAuthorised(true)
          const tokenFromApi = resp?.data?.data?.token
          setToken(tokenFromApi)
          const UserType = resp?.data?.data?.user?.type
          dispatch(saveToken(tokenFromApi)) // Dispatch the action to store token and userType in Redux
          dispatch(saveUserType(UserType))
          dispatch(saveAthurised(true))
          setalertMessage('You are successfully logged in')
          setAlertOpen(true)
          setLoginSuccess(true)
          if (rememberCheck) {
            const encryptedUsername = CryptoJS.AES.encrypt(
              email,
              Secretkey
            ).toString()
            const encryptedPassword = CryptoJS.AES.encrypt(
              password,
              Secretkey
            ).toString()
            localStorage.setItem('encryptedUsername', encryptedUsername)
            localStorage.setItem('encryptedPassword', encryptedPassword)
            localStorage.setItem('rememberMeChecked', 'true')
          } else {
            setEmail('')
            setPassWord('')
            localStorage.setItem('rememberMeChecked', 'false')
          }
          localStorage.setItem('accessToken', tokenFromApi)
          handleLoginSuccess(tokenFromApi, resp)
          localStorage.setItem('userType', resp?.data?.data?.user?.type)
          setUserType(resp?.data?.data?.user?.type)
          localStorage.setItem('userId', resp?.data?.data?.user?.userId)
        } else {
          setError(resp?.response?.data?.error?.message)
        }
      })
    } else {
      setError('Please enter credentials and try again.')
    }
  }

  const navigateToHomePage = (tokenFromApi, UserType) => {
    if (UserType === 'admin') {
      navigate('/dashboard', { state: { tokenFromApi, loginSuccess: true } })
    } else {
      navigate('/solarplantlist', {
        state: { tokenFromApi, loginSuccess: true },
      })
    }
  }

  const handleRemember = () => {
    setRememberCheck(!rememberCheck)
    localStorage.setItem('rememberMeChecked', !rememberCheck)
  }

  const alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setAlertOpen(false)
  }

  const navigateForgotpassowrd = () => {
    setLoginorForgot(!loginorForgot)
  }

  const handleForgotpassword = () => {
    if (email.length) {
      const data = {
        email: email,
      }
      ForgotPassword(data).then((resp) => {
        if (resp) {
          setLoginorForgot(true)
          setalertMessage('Password Reset Successful')
          setAlertOpen(true)
        }
      })
    } else {
      setError('Please enter credentials and try again.')
    }
  }

  return (
    <div className={classes.root}>
      <CustomAlert
        handleClose={alertClose}
        open={alertOpen}
        message={
          logoutSuccess ? alertMessage : 'You are successfully logged in'
        }
      />
      <Box>
        <Grid container style={{ height: '100vh' }}>
          <Grid xs={12} md={6} p={2} pl={4} style={{ padding: '30px 60px' }}>
            <div className={classes.verticalalign}>
              <div>
                <div className={classes.welcomediv}>
                  <div className={classes.welcometext}>Welcome to</div>
                </div>
                <div>
                  <div className={classes.headtext}>Solar Plant</div>
                  <div className={classes.headsectext}>
                    Monitoring Dashboard
                  </div>
                </div>
              </div>
              <div className={classes.textCenter}>
                <img
                  className={classes.Solarplantimg}
                  src={Solarplant}
                  alt="Solarplant"
                  style={{ width: '100%' }}
                ></img>
              </div>
              <div>
                <div className={classes.bottomdiv}>
                  <div className={classes.distributedbottom}>
                    <img
                      style={{ height: 50, width: 130 }}
                      src={LogoP1}
                      alt="logo"
                    />
                  </div>
                  <div className={classes.renewdiv}>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          {loginorForgot ? (
            <Grid xs={12} md={6}>
              <div
                style={{
                  backgroundImage: `url(${Background})`,
                  height: '100vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <div className={classes.loginContainer}>
                  <div className={classes.logintext}>Login</div>
                  <div style={{ padding: '3.188rem' }}>
                    <br />
                    <form autoComplete="off">
                      <div
                        className={`custom-text-field ${email ? 'has-value' : ''
                          }`}
                      >
                        <input
                          type="text"
                          id="custom-text-input"
                          value={email}
                          onChange={handleuUsernameChange}
                        />
                        <label htmlFor="custom-text-input">Username</label>
                        <span className="underline"></span>
                        <span>
                          <img
                            className="start-icon"
                            src={UserIcon}
                            alt="UserIcon"
                          />
                        </span>
                      </div>
                    </form>
                    {/* password input field */}
                    <div
                      className={`custom-text-field ${password ? 'has-value' : ''
                        }`}
                      style={{ marginTop: '30px' }}
                    >
                      <input
                        type="password"
                        id="custom-text-input-password"
                        value={password}
                        onChange={handleChange}
                      />
                      <label htmlFor="custom-text-input-password">
                        Password
                      </label>
                      <span className="underline"></span>
                      <span>
                        <img
                          className="start-icon"
                          src={Lockicon}
                          alt="Lockicon"
                        />
                      </span>
                    </div>
                    <div className={classes.bottomdiv}>
                      <div className={classes.distributedbottom}>
                        <Checkbox
                          sx={{
                            '&:hover': { bgcolor: 'transparent' },
                            padding: 0,
                          }}
                          disableRipple
                          color="default"
                          checkedIcon={<BpCheckedIcon />}
                          icon={<BpIcon />}
                          checked={rememberCheck}
                          onClick={handleRemember}
                          inputProps={{ 'aria-label': 'Checkbox demo' }}
                        />
                        <div
                          className={classes.lighbluetext}
                          style={{ marginLeft: '5px' }}
                        >
                          Remember Me
                        </div>
                      </div>
                      <div className={classes.distributedbottom}>
                        <div
                          className={classes.lighbluetext}
                          onClick={navigateForgotpassowrd}
                          style={{ cursor: 'pointer' }}
                        >
                          Forgot Password?
                        </div>
                      </div>
                    </div>
                    {error && (
                      <div className={classes.errorText}>{error} !</div>
                    )}
                    <div className={classes.distributedbottom}>
                      <div style={{ width: '50%', marginTop: '2.563rem' }}>
                        <ColorButton
                          onClick={handleLogin}
                          fullWidth
                          size="medium"
                          variant="outlined"
                        >
                          Login
                        </ColorButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          ) : (
            <Grid xs={12} md={6}>
              <div
                style={{
                  backgroundImage: `url(${Background})`,
                  height: '100vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <div
                  className={classes.loginContainer}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <div className={classes.resettext}>Forgot your Password?</div>
                  <div className={classes.resettextdetails}>
                    Please enter your email address.You will get your new
                    temporary password via email
                  </div>
                  <div
                    style={{
                      paddingLeft: '3.188rem',
                      paddingRight: '3.188rem',
                    }}
                  >
                    <br />
                    <form autoComplete="off">
                      <div
                        className={`custom-text-field ${email ? 'has-value' : ''
                          }`}
                      >
                        <input
                          type="text"
                          id="custom-text-input-2"
                          value={email}
                          onChange={handleuUsernameChange}
                        />
                        <label htmlFor="custom-text-input-2">Username</label>
                        <span className="underline"></span>
                        <span>
                          <img
                            className="start-icon"
                            src={UserIcon}
                            alt="UserIcon"
                          />
                        </span>
                      </div>
                    </form>
                    <div className={classes.bottomdiv}>
                      <div className={classes.distributedbottom}></div>
                      <div className={classes.distributedbottom}>
                        <div
                          className={classes.lighbluetext}
                          onClick={navigateForgotpassowrd}
                          style={{ cursor: 'pointer' }}
                        >
                          Login
                        </div>
                      </div>
                    </div>
                    {error && (
                      <div className={classes.errorText}>{error} !</div>
                    )}
                    <div className={classes.distributedbottom}>
                      <div style={{ width: '50%', marginTop: '2.563rem' }}>
                        <ColorButton
                          onClick={handleForgotpassword}
                          fullWidth
                          size="medium"
                          variant="outlined"
                        >
                          Reset Password
                        </ColorButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  )
}

Login.propTypes = {}

export default Login
